import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrearAseguradoraComponent } from '../crear-aseguradora/crear-aseguradora.component'
import { FileUploader } from 'ng2-file-upload';
// Service
import { GeneralService } from 'src/app/core/services/general.service';

@Component({
    selector: 'edit-user-modal',
    templateUrl: './edit-user-modal.component.html',
  })
  export class EditUserModal implements OnInit {

    uploader:FileUploader;
    editUserForm: FormGroup;
    public mask = ['(', '+', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

    noType = false;
    loadingFile = false;
    file = '.png / .jpg';

    constructor(
      public dialogRef: MatDialogRef<CrearAseguradoraComponent>,
      @Inject(MAT_DIALOG_DATA) public data,
      private fb: FormBuilder,
      private cdr: ChangeDetectorRef,
      private generalService: GeneralService
    ) {
        this.uploader = new FileUploader({
			disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
			formatDataFunctionIsAsync: true,
			formatDataFunction: async (item) => {
				return new Promise( (resolve, reject) => {
					resolve({
						name: item._file.name,
						length: item._file.size,
						contentType: item._file.type,
						date: new Date()
					});
				});
			}
		});
		this.uploader.onAfterAddingFile = (file) => {
			this.noType = false;
			if (file.file?.type === "image/png" || file.file?.type === "image/jpeg") {
				this.uploadFile(file);
			} else {
				this.noType = true;
			}
		}
    }

    ngOnInit(): void {
        const data = this.data.data
        this.file = data.logo.name;
        this.editUserForm = this.fb.group({
            name: [data.names, Validators.required],
            lastname: [data.lastnames, Validators.required],
            id: [data.id, Validators.required],
            userPhone: [data.phone, Validators.required],
            userEmail: [data.email, Validators.compose([Validators.required, Validators.email])],
            logo: [data.logo, Validators.required],
        })
    }

    onNoClick(form): void {
        if (form) {
            if (form.invalid) {
                const controls = form.controls;
                Object.keys(controls).forEach(controlName =>
                    controls[controlName].markAsTouched()
                );
                return;
            } else {
                this.dialogRef.close({value: form.value, index: this.data.data.index});
            }
        } else {
            this.dialogRef.close(form);
        }
    }

    uploadFile(file) {
		this.loadingFile = true;
		var formdata = new FormData();
		formdata.append("file", file.file.rawFile, file.file.name);
		formdata.append("folder", "firma_aseguradora");
		this.generalService.uploadFile(formdata).subscribe((res: any) => {
            this.file = res.fileName;
            this.editUserForm.patchValue({
                logo: {id: res.fileId, name: res.fileName}
            })
			this.loadingFile = false;
			this.cdr.markForCheck();
		}, err => {
			// console.log(err);
			this.loadingFile = false;
			this.cdr.markForCheck();
		})
	}

    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.editUserForm.controls[controlName];
        if (!control) {
            return false;
        }

        const result = control.hasError(validationType) && (control.dirty || control.touched);
        return result;
    }
  }
